import { BOOKING_CODE_REGEX } from "store/constants/regexes";

export const checkBookingCodeRule = (e) => {
  const regex = new RegExp(BOOKING_CODE_REGEX);
  var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  return regex.test(key);
};
